<template>
  <footer class="app-modal-footer">
    <slot />
  </footer>
</template>

<script>
export default {
  name: 'AppModalFooter',
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-modal-footer {
  padding: $defaultPadding;
  display: flex;
  flex-direction: row-reverse;

  > .app-button {
    margin-right: #{math.div($defaultPadding, 4)};

    &:first-child {
      margin-right: 0;
    }
  }
}
</style>
